module.exports = __webpack_public_path__ + "static/media/winter_super_pack_cat_FR.8b3e92f4.png";